"use client"

// Previously this dimmed the whole page behind a loader until window "load" (every image and
// script downloaded) + 800ms, and added a fixed delay to every navigation. On mobile that held
// the hero back for tens of seconds (PageSpeed LCP "render delay"). Content now shows immediately.
export function LoadingProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
